import { useState } from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import NetworkView from "../Team/NetworkView";
import NetworkVisualization from "../Team/NetworkVisualization";
import { useNetwork } from "./hooks/use-network";
// import TeamSearch from "./TeamSearch";
import TeamSummary from "./TeamSummary";
import ProfileCard from "./ProfileCard";
import ExportExcel from "./ExportExcel";


const Team = () => {
    const [showVisualization, setShowVisualization] = useState(false);
    const [activeTab, setActiveTab] = useState("network");


    const {
        currentUserId,
        isLoading,
        isLevelLoading,
        isError,
        error,
        userData,
        teamMembers,
        totalUsers,
        totalActiveUsers,
        navigationHistory,
        currentLevel,
        visitedUsers,
        networkLevels,
        loadMyNetwork,
        refreshNetwork,
        copyReferralLink,
        shareViaWhatsApp,
        shareViaEmail,
        loadUserNetwork,
        navigateToLevel
    } = useNetwork();

    const activityPercentage =
        totalUsers > 0
            ? Math.round((totalActiveUsers / totalUsers) * 100)
            : 0;

    if (showVisualization) {
        return (
            <NetworkVisualization
                teamMembers={teamMembers}
                currentUserId={currentUserId}
                userData={userData}
                onViewNetwork={loadUserNetwork}
                isLoading={isLoading}
                onClose={() => setShowVisualization(false)}
            />
        );
    }

    return (
        <>
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k || "network")}
                className="mb-4"
            >
                <Tab eventKey="network" title="Mi Red">
                    <div className="pt-2">
                       {/*  <TeamSearch
                            search={search}
                            level={level}
                            status={status}
                            onSearchChange={setSearch}
                            onLevelChange={setLevel}
                            onStatusChange={setStatus}
                        /> */}

                        <TeamSummary
                            totalUsers={totalUsers}
                            activeUsers={totalActiveUsers}
                            activityPercentage={activityPercentage}
                            directUsers={teamMembers.length}
                        />

                        <Row>
                            <Col md={3}>
                                <ProfileCard
                                    isLoading={isLevelLoading}
                                    photo={userData?.photo || ""}
                                    userParent={userData?.parent?.name || "..."}
                                    emailParent={userData?.parent?.email || "..."}
                                    userName={userData?.name || "..."}
                                    referralCode={userData?.multyhealth_code || "..."}
                                    networkLevels={networkLevels}
                                    onCopyLink={copyReferralLink}
                                    onShareWhatsApp={shareViaWhatsApp}
                                    onShareEmail={shareViaEmail}
                                />
                            </Col>

                            <Col md={9}>
                                <NetworkView
                                    visitedUsers={visitedUsers}
                                    teamMembers={teamMembers}
                                    isLoading={isLoading}
                                    isError={isError}
                                    error={error}
                                    currentUserId={currentUserId}
                                    navigationHistory={navigationHistory}
                                    currentLevel={currentLevel}
                                    onViewNetwork={loadUserNetwork}
                                    onRefresh={refreshNetwork}
                                    onBackToMyNetwork={loadMyNetwork}
                                    onNavigateToLevel={navigateToLevel}
                                    onShowVisualization={() => setShowVisualization(true)}
                                />
                            </Col>
                        </Row>
                    </div>
                </Tab>

                <Tab eventKey="export" title="Filtros y Exportación">
                    <div className="pt-2">
                        <ExportExcel/>
                    </div>
                </Tab>
            </Tabs>
        </>
    );
};

export default Team;